import { InitialPhone } from "./Phone";
import { UserDTO } from "./dto/UserDTO";

export interface UserState {
    currentUser: UserDTO;
    clients: UserDTO[];

    //blocked users list
    rows: UserDTO[];
    totalRows: number;
    totalPages: number;
}

const initialUserDTO: UserDTO = {
    id: null,
    isDeleted: false,
    isBlocked: false,
    firstName: "",
    lastName: "",
    referralToken: undefined,
    phones: [InitialPhone, InitialPhone],
    avgRating: 5,
    reviewsCount: 0,
};

export const InitialUser: UserState = {
    currentUser: initialUserDTO,
    clients: [],

    //blocked users list
    rows: [],
    totalRows: 0,
    totalPages: 0,
};
